import React, { useContext } from 'react';
import './footer.css';
import { Link } from "react-router-dom"
import { DidomiContext } from 'root/root';
export const Footer = () => {
  const didomi = useContext(DidomiContext);

  const gestionCookies = (didomiObject:any) => {
    if (didomiObject) didomiObject.preferences.show();
  };
  
  return (
    <div data-testid={"footer"} className="main-footer">
      <div className="container"> 
        <div className=" justify-content-center align-items-center box-footer">
         <div className="box-label">
          <Link to="https://assurances.spb.eu/mentionsLegales/fr.html"  target="_blank" className='text'><span className='point'>•</span> Mentions légales</Link>
        </div>
        <div className="box-label">
          <Link to="https://assurances.spb.eu/documents/CGU.pdf"  target="_blank" className='text'><span className='point'>•</span> Conditions Générales d'Utilisation</Link>
        </div>
          <div className="box-label">
            <Link to="https://assurances.spb.eu/documents/CharteConfidentialite.pdf"  target="_blank"className='text'><span className='point'>•</span> Charte de confidentialité</Link>
        </div>
        <div className="box-label" onClick={() => gestionCookies(didomi)}>
            <Link to="/" className='text'><span className='point'>•</span> Cookies</Link>
        </div>
       </div> 
      </div>
    </div>
  )
}

export default Footer

